// types
import type { SectionHeaderProps } from './SectionHeader.types';

// styles
import {
  VAlignBox,
  IconBox,
  Separator
} from '../SectionToggle/SectionToggle.styles';

const SectionHeader = ({ label, icon }: SectionHeaderProps) => {
  'use memo';
  return (
    <VAlignBox>
      {icon && <IconBox>{icon}</IconBox>}

      {label}

      <Separator />
    </VAlignBox>
  );
};

export default SectionHeader;
